import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectDegradedSystems } from 'app/store/healthcheck';
import { HealthcheckOverlay } from './HealthcheckOverlay.jsx';

const mapStateToProps = createStructuredSelector({
    degradedSystems: selectDegradedSystems
});

export const HealthcheckOverlayContainer = connect(mapStateToProps)(HealthcheckOverlay);
